export default __webpack_public_path__ + "static/media/7@2x.2a4f903b.png";